import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQSection = () => {
  const faqs = [
    {
      question: "O que é o MarketPro Tools?",
      answer: "Uma plataforma de marketing digital com IA, planilhas inteligentes e ferramentas de execução.",
    },
    {
      question: "Preciso ter experiência?",
      answer: "Não. Foi criado para iniciantes.",
    },
    {
      question: "Posso cancelar quando quiser?",
      answer: "Sim.",
    },
    {
      question: "Serve para infoprodutores, afiliados e pequenas empresas?",
      answer: "Sim.",
    },
    {
      question: "Tem suporte?",
      answer: "Sim, em português.",
    },
  ];

  return (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-5xl font-bold text-foreground mb-4">
            ❓ Perguntas Frequentes
          </h2>
        </div>

        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="bg-card rounded-lg shadow-medium px-6 border-none"
              >
                <AccordionTrigger className="text-left text-lg font-semibold text-foreground hover:text-primary hover:no-underline py-6">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
